(function(){'use strict';function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return exports;
  };
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function (method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct.bind();
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }
  return _construct.apply(null, arguments);
}
function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;
  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;
    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);
      _cache.set(Class, Wrapper);
    }
    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }
    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };
  return _wrapNativeSuper(Class);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}var CatalogQuantitySelector=function(t){_inherits(a,t);var e,n,i=_createSuper(a);function a(){return _classCallCheck(this,a),i.apply(this,arguments)}return _createClass(a,[{key:"connectedCallback",value:function(){var t,e,n,i,a,r,l,s,u,o,c=this;this.abortController=new AbortController,this.inputElement=this.querySelector("input"),this.checkboxElement=this.findCheckboxElement(),this.catalogStep=(null===(t=this.inputElement)||void 0===t?void 0:t.dataset.catalogIncrement)||(null===(e=this.inputElement)||void 0===e?void 0:e.step)||"1",this.defaultStep=(null===(n=this.inputElement)||void 0===n?void 0:n.dataset.singleStep)||(null===(i=this.inputElement)||void 0===i?void 0:i.dataset.defaultStep)||(null===(a=this.inputElement)||void 0===a?void 0:a.step)||"1",this.catalogMin=(null===(r=this.inputElement)||void 0===r?void 0:r.dataset.catalogMin)||(null===(l=this.inputElement)||void 0===l?void 0:l.getAttribute("min"))||"1",this.singleItemMin=(null===(s=this.inputElement)||void 0===s?void 0:s.dataset.singleMin)||(null===(u=this.inputElement)||void 0===u?void 0:u.dataset.defaultMin)||"1",this.valueController=this.handleManualInput.bind(this),this.variantId=this.getVariantId(),this.quantityPriceBreaks=this.parseQuantityPriceBreaks(),this.defaultPrice=this.dataset.defaultPrice?parseFloat(this.dataset.defaultPrice):0,0===this.quantityPriceBreaks.length&&window.variant&&window.variant.quantity_price_breaks&&(this.quantityPriceBreaks=window.variant.quantity_price_breaks.map((function(t){return {min:t.minimum_quantity,price:t.price}})),this.defaultPrice=window.variant.price||this.defaultPrice),this.cartQuantity=0,this.initializeWithCartData(),document.addEventListener("visibilitychange",(function(){document.hidden||c.fetchCartQuantity().then((function(){c.updatePrice();}));})),document.addEventListener("cart:change",(function(){c.fetchCartQuantity().then((function(){c.updatePrice();}));})),document.addEventListener("cart:refresh",(function(){c.fetchCartQuantity().then((function(){c.updatePrice();}));})),document.addEventListener("line-item:change",(function(){c.fetchCartQuantity().then((function(){c.updatePrice();}));})),this.checkboxElement&&this.checkboxElement.addEventListener("change",this.onCheckboxChange.bind(this),{signal:this.abortController.signal}),this.querySelector("button:first-of-type").addEventListener("click",this.stepDown.bind(this),{signal:this.abortController.signal}),this.querySelector("button:last-of-type").addEventListener("click",this.stepUp.bind(this),{signal:this.abortController.signal}),this.inputElement&&(this.inputElement.addEventListener("change",this.valueController,{signal:this.abortController.signal}),this.inputElement.addEventListener("input",this.valueController,{signal:this.abortController.signal}));var h=null===(o=this.inputElement)||void 0===o?void 0:o.form;h&&h.addEventListener("submit",(function(){c.applyCatalogValueConstraint(),c.updateCatalogProperties(!!c.checkboxElement&&c.checkboxElement.checked);}),{signal:this.abortController.signal}),this.updateStep();}},{key:"findCheckboxElement",value:function(){if(this.dataset.checkboxId){var t=document.getElementById(this.dataset.checkboxId);if(t)return t}var e=this.inputElement.id.replace("-quantity","-single-item"),n=document.getElementById(e);if(n)return n;var i=this.inputElement.form;if(i){var a=Array.from(i.querySelectorAll('input[type="checkbox"]')).find((function(t){return t.id.includes("single-item")}));if(a)return a}var r=document.querySelectorAll('input[type="checkbox"][id*="single-item"]');return r.length>0?r[0]:null}},{key:"onCheckboxChange",value:function(){var t=!!this.checkboxElement&&this.checkboxElement.checked;if(this.updateStep(),this.inputElement){var e=this.singleItemMin||"1",n=t?e:this.catalogMin;this.inputElement.value=n,this.inputElement.dispatchEvent(new Event("change",{bubbles:!0}));}this.updatePrice();}},{key:"updateStep",value:function(){var t="true"===this.inputElement.dataset.hasCatalog,e=!!this.checkboxElement&&this.checkboxElement.checked,n=t&&!e;n?(this.inputElement.step=this.catalogStep,this.inputElement.min=this.catalogMin):(this.inputElement.step=this.defaultStep,this.inputElement.min=this.singleItemMin),t&&(this.applyCatalogValueConstraint({force:n}),this.updateCatalogProperties(e));}},{key:"stepDown",value:function(){var t,e="true"===this.inputElement.dataset.hasCatalog,n=this.getCatalogIncrement(),i=!!this.checkboxElement&&this.checkboxElement.checked,a=e&&!i,r=parseInt(this.inputElement.min,10)||1,l=parseInt(this.inputElement.value,10);if(Number.isNaN(l)&&(l=r),l=a?this.normalizeCatalogValue(l):Math.max(r,l),a)t=l<=n?r:Math.max(r,l-n);else {var s=parseInt(this.inputElement.step,10)||1;t=Math.max(r,l-s);}t=this.applyMaxConstraint(t),this.inputElement.value=t,this.inputElement.dispatchEvent(new Event("change",{bubbles:!0})),this.updatePrice();}},{key:"stepUp",value:function(){var t,e="true"===this.inputElement.dataset.hasCatalog,n=this.getCatalogIncrement(),i=!!this.checkboxElement&&this.checkboxElement.checked,a=e&&!i,r=this.inputElement.max?parseInt(this.inputElement.max,10):null,l=parseInt(this.inputElement.min,10)||1,s=parseInt(this.inputElement.value,10);(Number.isNaN(s)&&(s=l),s=a?this.normalizeCatalogValue(s):Math.max(l,s),a)?t=s<n?n:s+n:t=s+(parseInt(this.inputElement.step,10)||1);t=this.applyMaxConstraint(t,r),this.inputElement.value=t,this.inputElement.dispatchEvent(new Event("change",{bubbles:!0}));}},{key:"handleManualInput",value:function(){this.applyCatalogValueConstraint(),this.updatePrice();}},{key:"getCatalogPropertyInputs",value:function(){var t=this.inputElement.form;if(!t)return [];var e=new Set;t.querySelectorAll("input[data-catalog-property]").forEach((function(t){return e.add(t)}));var n=t.getAttribute("id");return n&&document.querySelectorAll('input[data-catalog-property][form="'.concat(n,'"]')).forEach((function(t){return e.add(t)})),Array.from(e)}},{key:"updateCatalogProperties",value:function(t){var e=this,n=this.getCatalogPropertyInputs(),i=!t;n.forEach((function(t){var n=t.dataset.catalogProperty;if("mode"===n)return t.disabled=!1,void(t.value=i?"catalog":"single");i?(t.disabled=!1,"is-item"===n&&(t.value="true"),"increment"===n&&(t.value=e.getCatalogIncrement())):(t.value="",t.disabled=!0);}));}},{key:"shouldUseCatalogMode",value:function(){return !("true"!==this.inputElement.dataset.hasCatalog)&&(!this.checkboxElement||!this.checkboxElement.checked)}},{key:"normalizeCatalogValue",value:function(t){var e=parseInt(t,10),n=parseInt(this.inputElement.min,10)||1,i=this.getCatalogIncrement();if(Number.isNaN(e)||e<=n)return n;var a=e%i,r=e-a;if(0===a)return Math.max(n,r);var l=r,s=r+i;return Math.abs(e-l)<=Math.abs(s-e)?Math.max(n,l||i):Math.max(n,s)}},{key:"applyCatalogValueConstraint",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},e=t.force,n=void 0!==e&&e,i=this.shouldUseCatalogMode();if((i||n)&&(i||n)){var a=this.normalizeCatalogValue(this.inputElement.value),r=this.applyMaxConstraint(a);this.inputElement.value=r;}}},{key:"applyMaxConstraint",value:function(t){var e,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:null;return e=null!==n?n:this.inputElement.max?parseInt(this.inputElement.max,10):null,Number.isInteger(e)&&t>e?e:t}},{key:"getCatalogIncrement",value:function(){return parseInt(this.inputElement.dataset.catalogIncrement,10)||1}},{key:"parseQuantityPriceBreaks",value:function(){try{var t=this.dataset.quantityPriceBreaks;return t?t.split(",").map((function(t){var e=t.split(":").map(Number),n=_slicedToArray(e,2);return {min:n[0],price:n[1]}})):[]}catch(t){return []}}},{key:"getVariantId",value:function(){var t,e=null===(t=this.inputElement)||void 0===t?void 0:t.form;if(e){var n=e.querySelector('input[name="id"]');if(n)return parseInt(n.value,10)}var i=new URLSearchParams(window.location.search).get("variant");return i?parseInt(i,10):window.variant&&window.variant.id?window.variant.id:null}},{key:"initializeWithCartData",value:(n=_asyncToGenerator(_regeneratorRuntime().mark((function t(){return _regeneratorRuntime().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return t.next=2,this.fetchCartQuantity();case 2:this.updatePrice();case 3:case"end":return t.stop()}}),t,this)}))),function(){return n.apply(this,arguments)})},{key:"fetchCartQuantity",value:(e=_asyncToGenerator(_regeneratorRuntime().mark((function t(){var e,n,i,a,r=this;return _regeneratorRuntime().wrap((function(t){for(;;)switch(t.prev=t.next){case 0:if(this.variantId){t.next=2;break}return t.abrupt("return");case 2:return t.prev=2,t.next=5,fetch("".concat(window.Shopify.routes.root,"cart.js"));case 5:return n=t.sent,t.next=8,n.json();case 8:i=t.sent,a=null===(e=i.items)||void 0===e?void 0:e.find((function(t){return t.variant_id===r.variantId})),this.cartQuantity=a?a.quantity:0,t.next=16;break;case 13:t.prev=13,t.t0=t.catch(2),this.cartQuantity=0;case 16:case"end":return t.stop()}}),t,this,[[2,13]])}))),function(){return e.apply(this,arguments)})},{key:"getCurrentPrice",value:function(t){for(var e=parseInt(t,10)+this.cartQuantity,n=this.quantityPriceBreaks.length-1;n>=0;n-=1){var i=this.quantityPriceBreaks[n];if(e>=i.min)return i.price}return this.defaultPrice}},{key:"updatePrice",value:function(){var t;if(this.inputElement&&0!==this.quantityPriceBreaks.length){var e=parseInt(this.inputElement.value,10)||1,n=this.getCurrentPrice(e),i=null===(t=this.closest(".product-info__price"))||void 0===t?void 0:t.querySelector("price-list");if(i||(i=document.querySelector(".product-info__price price-list")),!i){var r,l=null===(r=this.inputElement)||void 0===r?void 0:r.form;l&&(i=l.querySelector(".product-info__price price-list"));}if(i){var s=i.querySelector("sale-price");if(s){var u=a.formatPrice(n);s.innerHTML='<span class="sr-only">Angebot</span>'.concat(u);}}}}},{key:"disconnectedCallback",value:function(){this.abortController.abort();}}],[{key:"formatPrice",value:function(t){return "€".concat((t/100).toFixed(2).replace(".",","))}}]),a}(_wrapNativeSuper(HTMLElement));window.customElements.get("catalog-quantity-selector")||window.customElements.define("catalog-quantity-selector",CatalogQuantitySelector);})();